import { useTranslation } from 'react-i18next';
import { TourFigureFrame } from './TourFigureFrame';

const K = 'tours.logistics.figures.dashboard';

/** The Dashboard's System Alerts card with its "View in Logistics" link. Labels via i18n. */
export function DashboardAlertsFigure() {
  const { t } = useTranslation();
  const rows = [
    { y: 50, fill: 'var(--color-error)', key: 'alert1' },
    { y: 68, fill: 'var(--amber)', key: 'alert2' },
    { y: 86, fill: 'var(--amber)', key: 'alert3' },
  ];
  return (
    <TourFigureFrame width={320} height={120} alt={t(`${K}.alt`)}>
      <text x="22" y="30" fontSize="11" fontWeight="600" fill="var(--navy)">{t(`${K}.title`)}</text>
      <text x="298" y="30" fontSize="9" fill="var(--g500)" textAnchor="end">{t(`${K}.today`)}</text>
      <g fontSize="9.5" fill="var(--navy)">
        {rows.map((r) => (
          <g key={r.key}>
            <circle cx="28" cy={r.y} r="3" fill={r.fill} />
            <text x="38" y={r.y + 3}>{t(`${K}.${r.key}`)}</text>
          </g>
        ))}
      </g>
      <rect x="200" y="94" width="100" height="14" rx="4" fill="var(--blue-tint)" />
      <text x="250" y="104" fontSize="9" fontWeight="600" fill="var(--status-planned-text)" textAnchor="middle">{t(`${K}.link`)}</text>
    </TourFigureFrame>
  );
}
